import { useCallback, useRef, useState, useEffect } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

import { FaSpinner } from 'react-icons/fa';
import styled from 'styled-components';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const PdfWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    background-color: #1e222b;
    position: relative;
    overflow: hidden;
`;

const DocumentArea = styled.div`
    flex: 1;
    overflow: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    padding: 16px;

    /* Scrollbar mais clean */
    &::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }
    &::-webkit-scrollbar-track {
        background: transparent;
        border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background: rgba(255, 255, 255, 0.35);
    }
`;

const Overlay = styled.div`
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #1e222b;
    color: #aaa;
`;

export function Pdf({ url }) {

    const [numPages, setNumPages] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const containerRef = useRef(null);

    const [pdfData, setPdfData] = useState(null);

    useEffect(() => {
        if (!url) return;
        fetch(url)
            .then((res) => res.arrayBuffer())
            .then((buffer) => setPdfData({ data: buffer }))
            .catch(onLoadError);
    }, [url]);

    const onLoadSuccess = useCallback(({ numPages }) => {
        setNumPages(numPages);
        setLoading(false);
    }, []);

    const onLoadError = useCallback((err) => {
        console.error(err);
        if (err?.message?.includes('Unexpected token')) {
            setError('O arquivo retornado não é um PDF válido (possível erro de rota ou backend)');
        } else {
            setError('Erro ao carregar PDF (CORS ou arquivo inválido)');
        }
        setLoading(false);
    }, []);

    return (
        <PdfWrapper>
            {loading && !error && (
                <Overlay>
                    <FaSpinner className="spin" size={24} color="#1D86FF" />
                </Overlay>
            )}

            {error && (
                <Overlay>
                    {error}
                </Overlay>
            )}

            <DocumentArea ref={containerRef}>
                {pdfData && (
                    <Document
                        file={pdfData}
                        onLoadSuccess={onLoadSuccess}
                        onLoadError={onLoadError}
                        loading={null}
                    >
                        {numPages &&
                            Array.from({ length: numPages }, (_, i) => (
                                <Page
                                    key={`page_${i + 1}`}
                                    pageNumber={i + 1}
                                    renderTextLayer={false}
                                    renderAnnotationLayer={false}
                                    className="pdf-page-custom"
                                />
                            ))}
                    </Document>
                )}
            </DocumentArea>
        </PdfWrapper>
    );
}